import DatricRequests from '../datric.requests';
import { ApiKeyUsage, ClientStat, IndicatorStat, Overview, TimelinePoint } from '../../../models/dashboard.model';

const requests = new DatricRequests();

// includeStaff=true inclui ADMIN/SUPORTE nas contas; default (undefined) exclui.
function params(from?: string, to?: string, includeStaff?: boolean) {
	return { from, to, includeStaff: includeStaff ? 'true' : undefined };
}

export async function getOverview(from?: string, to?: string, includeStaff?: boolean): Promise<Overview> {
	return requests.get('dashboard/overview', params(from, to, includeStaff));
}

export async function getByClient(from?: string, to?: string, includeStaff?: boolean): Promise<ClientStat[]> {
	return requests.get('dashboard/by-client', params(from, to, includeStaff));
}

export async function getByIndicator(from?: string, to?: string, includeStaff?: boolean): Promise<IndicatorStat[]> {
	return requests.get('dashboard/by-indicator', params(from, to, includeStaff));
}

export async function getTimeline(from?: string, to?: string, includeStaff?: boolean): Promise<TimelinePoint[]> {
	return requests.get('dashboard/timeline', params(from, to, includeStaff));
}

export async function getApiKeyUsage(from?: string, to?: string, includeStaff?: boolean): Promise<ApiKeyUsage[]> {
	return requests.get('dashboard/api-key-usage', params(from, to, includeStaff));
}
